import React from "react";
import ContentLoader from "react-content-loader";

function PostListLoading() {
  return (
    <div className="article img clearfix">
      <ContentLoader
        speed={2} // 속도
        // width={530}
        // height={180}
        viewBox="0 10 200 70"
        backgroundColor="#27292d" // 배경색
        foregroundColor="#4b4b4b" // 요소 색
      >
        <rect x="0" y="10" rx="1" ry="1" width="200" height="9" />
        <rect x="0" y="22" rx="1" ry="1" width="200" height="9" />
        <rect x="0" y="34" rx="1" ry="1" width="200" height="9" />
        <rect x="0" y="46" rx="1" ry="1" width="200" height="9" />
        <rect x="0" y="58" rx="1" ry="1" width="200" height="9" />
      </ContentLoader>
    </div>
  );
}

export default PostListLoading;
